// Restyles a Feefo on-page reviews widget. Feefo renders the widget inside its
// own (open) shadow root, out of reach of the theme's CSS, so this adds the
// stylesheet from data-stylesheet to that shadow root once it exists. The
// widget's host element gets the element's data-layout, for :host() rules.
// Feefo's class names aren't a public API: if they change, the widget falls
// back to Feefo's default look.
const sheets = new Map();

function loadSheet(url) {
  if (!sheets.has(url)) {
    sheets.set(
      url,
      fetch(url)
        .then((response) => (response.ok ? response.text() : Promise.reject(response)))
        .then((css) => new CSSStyleSheet().replace(css))
        .catch(() => null)
    );
  }
  return sheets.get(url);
}

class FeefoWidgetStyles extends HTMLElement {
  connectedCallback() {
    if (this.observer) return;

    // The widget's shadow host appears inside [data-ref-widget] when Feefo's
    // script renders it; its shadow root may be attached just after that.
    this.observer = new MutationObserver(() => this.apply());
    this.observer.observe(this.querySelector('[data-ref-widget]'), { childList: true, subtree: true });
    this.apply();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
    clearTimeout(this.retry);
  }

  async apply(attempt = 0) {
    const host = [...this.querySelectorAll('[data-ref-widget] *')].find((element) => element.shadowRoot);
    if (!host) {
      // Shadow root not attached yet: check again shortly (up to ~5s)
      if (this.querySelector('[data-ref-widget] *') && attempt < 50) {
        clearTimeout(this.retry);
        this.retry = setTimeout(() => this.apply(attempt + 1), 100);
      }
      return;
    }
    if (this.styledRoot === host.shadowRoot) return;
    this.styledRoot = host.shadowRoot;
    this.observer.disconnect();

    const sheet = await loadSheet(this.dataset.stylesheet);
    if (!sheet) return;
    host.dataset.layout = this.dataset.layout;
    host.shadowRoot.adoptedStyleSheets = [...host.shadowRoot.adoptedStyleSheets, sheet];
  }
}

customElements.define('component-feefo-widget-styles', FeefoWidgetStyles);
